export default (
  state = { openForWork: 0, editorId: null, copiedContent: null, copyClicked: 0, attachmentIds: [] },
  action
) => {
  switch (action.type) {
    case "ADD_OPEN":
      return Object.assign({}, state, {
        openForWork: state.openForWork + 1,
        editorId: action.editorId
      });
    case "REMOVE_OPEN":
      return Object.assign({}, state, {
        openForWork: state.openForWork - 1,
      });
    case "ADD_CONTENT":
      return Object.assign({}, state, {
        copiedContent: action.copiedContent,
        copyClicked: state.copyClicked + 1,
        attachmentIds: action.attachmentIds
      });
    case "EDITOR_FOCUSED":
      return Object.assign({}, state, {
        editorId: action.editorId
      });
    default:
      return state;
  }
};
